/** 將數值四捨五入到指定小數位數 */
export default function MathRound(num: number, len: number) {
  return Math.round(num * 10 ** len) / 10 ** len;
}
